import CardTableItem from './CardTableItem'

export default CardTableItem
